import { render, staticRenderFns } from "./areaUpdate.vue?vue&type=template&id=eddd73d8&scoped=true"
import script from "./areaUpdate.vue?vue&type=script&lang=js"
export * from "./areaUpdate.vue?vue&type=script&lang=js"
import style0 from "./areaUpdate.vue?vue&type=style&index=0&id=eddd73d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd73d8",
  null
  
)

export default component.exports